import { ref } from 'vue'
import { registerSW } from 'virtual:pwa-register'

/**
 * A new version is offered, never forced: an update that swaps the app out
 * from under a half-typed task is worse than running yesterday's build.
 */
export const needsRefresh = ref(false)
export const offlineReady = ref(false)

const update = registerSW({
  immediate: true,
  onNeedRefresh: () => (needsRefresh.value = true),
  onOfflineReady: () => (offlineReady.value = true),
})

/** Take the waiting version and reload. */
export async function applyUpdate(): Promise<void> {
  await update(true)
}
